import { BaseService } from "./base.service";

class AppAssetsService extends BaseService {
  constructor() {
    super("/app-assets");
  }

  async getVideoSignedUrl(fileName: string): Promise<string> {
    const res = await this.get<{ signedUrl: string }>(
      `/video-signed-url?file=${encodeURIComponent(fileName)}`
    );
    return res.signedUrl;
  }
}

export const appAssetsService = new AppAssetsService();
